import moment from 'moment';
import actions from './actions';

const initState = {
  errorMessage: null,
  isError: false,
  createNoteLoading: false,
  notes: null,
  notesLoading: false,
  notesHasMore: false,
  notesPagination: null,
  notesLoadMore: false,

  fileAccessURL: null,
  fileAccessURLLoading: false,
  fileAccessURLIsError: false
};

export default function filesReducer(state = initState, action) {
  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null
      };

    case actions.CREATE_NOTE_LOADING:
      return {
        ...state,
        createNoteLoading: true,
        isError: false
      };

    case actions.CREATE_NOTE_SUCCESS:
      return {
        ...state,
        createNoteLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.CREATE_NOTE_FAILED:
      return {
        ...state,
        createNoteLoading: false,
        errorMessage: action.message,
        isError: true
      };

    case actions.FETCHING_NOTES:
      return {
        ...state,
        notesLoading: true,
        isError: false,
        notesLoadMore: action.load_more
      };

    case actions.FETCH_NOTES_SUCCESS:
      const newNotes = !!action?.load_more
        ? [...(state?.notes ?? []), ...(action?.result ?? [])]
        : action?.result;

      return {
        ...state,
        notes: newNotes,
        notesLoading: false,
        errorMessage: action.message,
        isError: false,
        notesPagination: action.pagination
      };

    case actions.FETCH_NOTES_FAILED:
      return {
        ...state,
        notesLoading: false,
        errorMessage: action.message,
        isError: true,
        notesPagination: action.pagination
      };

    case actions.UPDATE_NOTE_LOADING:
      return {
        ...state,
        updateNoteLoading: true,
        isError: false
      };

    case actions.UPDATE_NOTE_SUCCESS:
      return {
        ...state,
        updateNoteLoading: false,
        errorMessage: action.message,
        isError: false,
        notes:
          state.notes?.map(item => {
            if (item.id === action.result.id) {
              return { ...item, ...(action?.result ?? {}) };
            }
            return item;
          }) || []
      };

    case actions.UPDATE_NOTE_FAILED:
      return {
        ...state,
        updateNoteLoading: false,
        errorMessage: action.message,
        isError: true
      };

    case actions.PIN_NOTE_LOADING:
      return {
        ...state,
        pinNoteLoading: true,
        isError: false
      };

    case actions.PIN_NOTE_SUCCESS:
      return {
        ...state,
        pinNoteLoading: false,
        errorMessage: action.message,
        isError: false,
        notes:
          state.notes
            ?.map(item => {
              if (item.id === action.result.id) {
                return { ...item, ...(action?.result ?? {}) };
              }
              return item;
            })
            .sort((a, b) => {
              // Pinned first
              if (a.is_pinned !== b.is_pinned) {
                return Number(b.is_pinned) - Number(a.is_pinned);
              }

              // Newest created_at first
              return moment(b.created_at).valueOf() - moment(a.created_at).valueOf();
            }) || []
      };

    case actions.PIN_NOTE_FAILED:
      return {
        ...state,
        pinNoteLoading: false,
        errorMessage: action.message,
        isError: true
      };

    default:
      return state;
  }
}
